import {AccessRequired} from "~/apps/core/ui/AccessRequired";
import {Route, Switch} from "react-router-dom";
import {IndexPage} from "./components/IndexPage";
import {BrowserRouter} from "~/apps/core/BrowserRouter";
import {useApolloClient} from "@apollo/client";
import {useEffect} from "react";
import {ServiceInterview} from "~/customers-experience/ServiceInterview";


export const APP_VERSION = "1.0.0";
export const APP_NAME = "customs-requirements";

const CustomsRequirementsApp = () => {
    const client = useApolloClient();

    // Invalidate apollo cache when leave service
    useEffect(() => () => {
        client.cache.evict({id: "ROOT_QUERY", fieldName: "customsRequirements"});
    }, []);

    return (
        <AccessRequired title="Требования">
            <BrowserRouter basename="/apps/customs-requirements">
                <ServiceInterview serviceID={APP_NAME} serviceVersion={APP_VERSION}>
                    <Switch>
                        <Route path="*">
                            <IndexPage/>
                        </Route>
                    </Switch>
                </ServiceInterview>
            </BrowserRouter>
        </AccessRequired>
    )
}


export default CustomsRequirementsApp;